module.exports = __webpack_public_path__ + "media/images/team/ben-gagni-74827d2b2de68f6be66c58a17f25f5a2.png";